// extracted by mini-css-extract-plugin
export var details = "_lv-0";
export var inspectorPopover = "_lv-1";